import { cn } from "@/lib/cn";
import styled from "styled-components";
export const Icon = ({
  icon,
  size = 16,
  color = "#12033E",
  className,
}: {
  icon: string;
  size?: number;
  color?: string;
  className?: string;
}) => {
  if (icon?.startsWith("sd-"))
    return (
      <svg className={cn("sd-remix", className)} width={size} height={size}>
        <use xlinkHref={`/assets/custom.symbol.svg#${icon}`} fill={color}></use>
      </svg>
    );
  if (icon?.startsWith("ri-"))
    return (
      <IconStyled
        className={cn(icon, className)}
        $color={color}
        $size={size}
      ></IconStyled>
    );
  return (
    <IconStyled
      className={cn("material-icons", className)}
      $color={color}
      as="span"
      $size={size}
    >
      {icon}
    </IconStyled>
  );
};

const IconStyled = styled.i<{ $size: number; $color: string }>`
  font-size: ${({ $size }) => $size}px;
  color: ${({ $color }) => $color};
  line-height: 1;
  font-weight: normal;
  &.material-icons {
    font-size: ${({ $size }) => $size}px !important;
  }
`;
